/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './FormElementContainer.scss';

import CloseIcon from 'assets/icons/remove.svg';

const FormElementContainer = ({
  children, isRtl, isMultpleElements, isWithIconButton, isLightBg, isWithPadding,
  isWithClose, onClose, customClass,
}) => {
  const classes = classNames({
    'form-element-container': true,
    'form-element-container--rtl': isRtl,
    'form-element-container--multiple': isMultpleElements,
    'form-element-container--withIconButton': isWithIconButton,
    'form-element-container--lightBg': isLightBg,
    'form-element-container--withPadding': isWithPadding,
  });
  return (
    <div className={`${classes} ${customClass}`}>
      {isWithClose && (
        <span className="form-element-container__close" onClick={onClose}>
          <img src={CloseIcon} alt="close" />
        </span>
      )}
      {children}
    </div>
  );
};

FormElementContainer.propTypes = {
  /** Children/ Elements */
  children: PropTypes.node,
  /** is right to left */
  isRtl: PropTypes.bool,
  /** is containing multiple elements (inputs, selects or buttons) */
  isMultpleElements: PropTypes.bool,
  /** is light bg */
  isLightBg: PropTypes.bool,
  /** show close icon? */
  isWithClose: PropTypes.bool,
  /** on close event */
  onClose: PropTypes.func,
};

FormElementContainer.defaultProps = {
  children: <></>,
  isRtl: false,
  isMultpleElements: false,
  isLightBg: false,
  isWithClose: false,
  onClose: () => {},
};

export default FormElementContainer;
